export const submitBtn = document.querySelector('.nav__btn-search');
export const form = document.querySelector('.nav__search');
export const resultsContainerBox = document.querySelector(
  '.results-container__box'
);
export const resultDetailsContainer = document.querySelector(
  '.result-details__container'
);
export const resultListContainer = document.querySelector(
  '.result-list__conatiner'
);
export const searchField = document.querySelector('.search__field');
export const searchResult = document.querySelector('.search-result');

export const modal = document.getElementById('loginModal');
export const modalOpenBtn = document.getElementById('signup-btn');
export const modalCloseBtn = document.getElementById('modalClose');
export const signUpBtn = document.querySelector('.header__btn-signup');
export const logOutBtn = document.querySelector('.header__btn-logout');
export const usersEmail = document.querySelector(
  '.header__usersEmail-container'
);

export const toReadBtn = document.querySelector('.nav__glasses');
export const favouritesBtn = document.querySelector('.nav__heart');
export const toReadContainer = document.getElementById('toRead-List');
export const favouritesContainer = document.getElementById('favourites-List');
export const toReadList = document.querySelector('.booksList-toRead__list');
export const favouritesList = document.querySelector(
  '.booksList-favourites__list'
);

export const toReadPlaceholder = document.querySelector('.toRead__placeholder');
export const favouritesPlaceholder = document.querySelector(
  '.favourites__placeholder'
);
export const mainPlaceholder = document.querySelector(
  '.result-details__placeholder'
);
